import { hasPerm } from "./permission";

// Usage: <el-button v-perm="'system:user:save'">, or v-perm="['a','b']" (OR-match).
export default {
  bind(el, binding) {
    const value = binding.value;
    if (!value) return;
    const codes = Array.isArray(value) ? value : [value];
    const ok = codes.some(hasPerm);
    if (!ok && el.parentNode) {
      el.parentNode.removeChild(el);
    }
  },
};
